import type { IconData } from '@stacksjs/iconify-core'

export const foodDrinkFishBone: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 18.285H32v3.05h-1.53Zm0-7.62H32v3.05h-1.53Zm-1.52 6.1h1.52v1.52h-1.52Zm0-3.05h1.52v1.52h-1.52Zm-1.53-4.57h3.05v1.52h-3.05Zm0 12.19h3.05v1.52h-3.05Zm0-6.1h1.53v1.53h-1.53Zm-1.52 4.57h1.52v1.53H25.9Zm0-9.14h1.52v1.52H25.9Zm0 1.52h-1.52v3.05h-3.05v-3.05h-1.52v3.05h-3.05v-6.09h-1.53v6.09h-3.04v-9.14h-6.1v1.52h4.57v16.77H6.09v1.52h6.1v-9.14h3.04v6.09h1.53v-6.09h3.05v3.04h1.52v-3.04h3.05v3.04h1.52z\"/><path fill=\"currentColor\" d=\"M4.57 15.235h3.04v3.05H4.57Zm-1.53 7.62h3.05v1.53H3.04Zm0-15.24h3.05v1.53H3.04Zm-1.52 12.19h1.52v3.05H1.52Zm0-10.66h1.52v3.04H1.52ZM0 12.185h1.52v7.62H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default foodDrinkFishBone
